"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineActivitySubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.OnlineActivitySubCategory = (0, type_utils_1.makeEnum)({
    /** Declared interests */
    DeclaredInterests: 'DECLARED_INTERESTS',
    /** Page views */
    PageViews: 'PAGE_VIEWS',
    /** Interaction events */
    InteractionEvents: 'INTERACTION_EVENTS',
    /** Fallback subcategory */
    OnlineActivity: 'ONLINE_ACTIVITY',
});
//# sourceMappingURL=onlineActivity.js.map